import request from '@/utils/request'

// 查询快乐8列表
export function listKl8(query) {
    return request({
        url: '/admin/lottery/kl8/list',
        method: 'get',
        params: query
    })
}

// 查询最新一期快乐8数据
export function latestKl8() {
    return request({
        url: '/admin/lottery/kl8/latest',
        method: 'get',
    })
}

// 初始化快乐8数据
export function initAllKl8() {
    return request({
        url: '/admin/lottery/kl8/initAll',
        method: 'post'
    })
}

// 补全快乐8历史数据
export function fillHistoryData() {
    return request({
        url: '/admin/lottery/kl8/fillHistoryData',
        method: 'post'
    })
}

// 获取快乐8号码出现次数
export function getKl8NumData() {
    return request({
        url: '/admin/lottery/kl8/getNumData',
        method: 'get',
    })
}

// 初始化快乐8统计数据
export function initAllKl8C() {
    return request({
        url: '/admin/lottery/kl8/initAllC',
        method: 'post'
    })
}

// 刷新快乐8缓存
export function refreshKl8Cache() {
    return request({
        url: '/admin/lottery/kl8/refreshCache',
        method: 'delete',
    })
}
// 生成快乐8
export function generateKl8(data) {
    return request({
        url: '/admin/lottery/kl8/generate',
        method: 'post',
        data:data
    })
}

// 查询快乐8中奖数据
export function getNumSort(query){
    return request({
        url: '/admin/lottery/kl8/getNumSort',
        method: 'get',
        params: query
    })
}

// 查询快乐8中奖数据
export function getKl8WinningData(query){
    return request({
        url: '/admin/lottery/kl8/getWinningData',
        method: 'get',
        params: query
    })
}

// 查询快乐8历史同期中奖数据
export function getNextKl8History(period){
    return request({
        url: '/admin/lottery/kl8/getNextHistory?period='+period,
        method: 'get'
    })
}
